export default __webpack_public_path__ + "static/media/emptyPretargeting.bab8afc5.svg";